import React from "react";
import { CloseOutlined } from "@ant-design/icons";
import styles from "../../style/components/filtertag.module.scss";

interface FilterTagProps {
  children: React.ReactNode;
  onClose?: () => void;
  closable?: boolean;
  onClick?: () => void;
  style?: React.CSSProperties;
}

const FilterTag: React.FC<FilterTagProps> = ({
  children,
  onClose,
  closable = false,
  onClick,
  style,
}) => {
  const className = `${styles.filterTag} ${onClick ? styles.clickable : ""}`;

  return (
    <div className={className} style={style} onClick={onClick}>
      <span>{children}</span>
      {closable && onClose && (
        <CloseOutlined
          className={styles.closeIcon}
          onClick={(e) => {
            e.stopPropagation();
            onClose();
          }}
        />
      )}
    </div>
  );
};

export default FilterTag;

